import React, { useRef, useState } from 'react';
import { FlexRow, usePaginatedQueryV8 } from 'motion-components';
import { Card } from 'react-bootstrap';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { gqlGetAppparams } from '../graphql';
import { DataGrid } from './global-grid';

/* ------------------- Build where (no filters yet) ------------------- */
function buildWhereFromFilterValues(_values: any): string {
  return JSON.stringify({});
}

/* ----------------------------------------------------------- */
/* ------------------- Καθολικές Παράμετροι ------------------ */
export const GlobalParamsSection = observer(() => {
  const { appStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('GlobalParamsSection');

  const location = useLocation<any>();
  const history = useHistory();
  const [selected, setSelected] = useState<any>(null);
  const { t } = useTranslation();

  /* ------------------- Query ------------------------------- */
  const initOrderBy = 'paramName ASC';
  const query = usePaginatedQueryV8(
    gqlGetAppparams,
    buildWhereFromFilterValues,
    location.state?.order ?? initOrderBy,
    appStore,
    true,
    {},
    true,
  );
  const {
    loading,
    data,
    dataCount,
    error,
    initPageIndex,
    gridPageChanged,
    queryParams,
    setQueryParams,
  } = query;

  const gridRef = useRef();

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  }

  return (
    <Card className="border-0 shadow-none">
      <Card.Header className="bg-transparent border-0">
        <FlexRow>
          <small className="text-muted">
            {t(
              'Καθολικά defaults. Παρακάμπτονται από τις Παραμέτρους ανά Τύπο Παραλήπτη ή ανά Χρήστη.',
            )}
          </small>
        </FlexRow>
      </Card.Header>
      <Card.Body className="nopadding">
        <DataGrid
          ref={gridRef}
          loading={loading}
          data={data}
          dataCount={dataCount}
          initPageIndex={initPageIndex}
          onPageChange={gridPageChanged}
          initOrderBy={queryParams?.order ?? initOrderBy}
          onOrderChange={(orderBy: string) => {
            const newQueryParams = { ...queryParams, order: orderBy };
            setQueryParams(newQueryParams);
            history.replace({
              pathname: location.pathname,
              state: {
                ...location.state,
                order: orderBy,
              },
            });
          }}
          selected={selected}
          setSelected={setSelected}
        />
      </Card.Body>
    </Card>
  );
});
